<div class="box-border h-full w-full border-r border-gray-200 bg-white">
  <div>
    <div class="flex flex-col justify-start gap-1 p-2">
      @for (item of navItems(); track item.label) {
        @if (item.items) {
          <div>
            <button
              tuiButton
              tuiChevron
              type="button"
              size="m"
              appearance="flat-grayscale"
              class="w-full !justify-start text-left"
              (click)="toggleExpand(item)"
            >
              {{ item.label }}
            </button>
            <tui-expand [expanded]="item.expanded?.() || false">
              <div class="flex flex-col gap-1 pb-1">
                @for (subItem of item.items; track subItem.href) {
                  <a
                    tuiButton
                    type="button"
                    size="m"
                    appearance="flat-grayscale"
                    class="ml-4 !h-10 !justify-start text-left"
                    [target]="subItem.target"
                    [href]="subItem.href"
                  >
                    {{ subItem.label }}
                  </a>
                }
              </div>
            </tui-expand>
          </div>
        } @else {
          <a
            tuiButton
            type="button"
            size="m"
            appearance="flat-grayscale"
            class="!justify-start"
            [target]="item.target"
            [href]="item.href"
          >
            {{ item.label }}
          </a>
        }
      }
    </div>
  </div>
</div>
